import { render, staticRenderFns } from "./deliverCode.vue?vue&type=template&id=00764dd4&scoped=true&"
import script from "./deliverCode.vue?vue&type=script&lang=js&"
export * from "./deliverCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00764dd4",
  null
  
)

export default component.exports